import { Component, OnInit,HostListener,OnDestroy} from '@angular/core';
import { BaseapiService } from '../baseapi.service';
import { Router } from '@angular/router'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
title='';
  showLogoutDropdown: boolean = false;
  // vars for session
  isSessionPopupOpen = false;
  private inactivityTimer: any;
  private warningTimer: any;
  private inactivityTime = 15 * 60 * 1000; // 15 minutes

  private warningTime = 14 * 60 * 1000; // 14 minutes
  countdown = 60;
  private countdownInterval: any;
  constructor(private _ser:BaseapiService, private _r:Router
    ) { }
    openLogoutDropdown(){
      this.showLogoutDropdown = !this.showLogoutDropdown;
    }
    logout(){
      var con =confirm("Do you want to Logout?")
      // alert()
      if (con === true){
        //alert("gggg")
        localStorage.setItem('access_token','');
        localStorage.setItem('device_id','');
        this._ser.changeUrl('false');
        this._r.navigate(['/login'])
      }else{

        // this._r.navigate(['/postservicefeedback']);
        this._ser.changeUrl('true');
        console.log("kkkk")
         this._r.navigate(['/notification'])
      }
      console.log(localStorage.getItem("device_id"))
      // else{
      //   alert("HHHH");
      //   return
      //   // this._r.navigate(['/notification']);
      //   //alert("Hiii")
      // }

     // this.logout();
      }
  ngOnInit() {
    //this.username=localStorage.getItem('username');
    if(localStorage.getItem('app_name')=='com.tatamotors.cvcustomercare'){
     this.title="Commercial Vehicle" ;
    }
    else if(localStorage.getItem('app_name')=='com.ttl.customersocialapp'){
      this.title="Passenger Vehicle" ;
    }

    //this.title=localStorage.getItem('username');

    // this.checkPreviousSession();
    this.resetInactivityTimer();
  }
  // inactive timer
  @HostListener('document:mousemove')
  @HostListener('document:keydown')
  @HostListener('document:click')
  resetInactivityTimer() {
    // Don't reset anything if popup is already open
    if (this.isSessionPopupOpen) {
      return;
    }

    // Clear previous timers
    if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
    if (this.warningTimer) clearTimeout(this.warningTimer);

    // localStorage.setItem('lastActive', Date.now().toString());

    // Start warning popup timer
    this.warningTimer = setTimeout(() => {
      this.isSessionPopupOpen = true;
      this.countdown = 60;
      this.countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          console.log(this.countdown,'this.countdown');
          this.countdown--;
        } else {
          this.logoutUser(); // auto logout if user doesn't act
        }
      }, 1000);
    }, this.warningTime);

    // Start logout timer
    this.inactivityTimer = setTimeout(() => {
      this.logoutUser();
    }, this.inactivityTime);
  }

  // checkPreviousSession() {
  //   const lastActive = localStorage.getItem('lastActive');
  //   if (lastActive) {
  //     const elapsedTime = Date.now() - parseInt(lastActive);
  //     if (elapsedTime >= this.inactivityTime) {
  //       this.logoutUser();
  //     } else {
  //       this.resetInactivityTimer();
  //     }
  //   }
  // }

  logoutUser() {
    this.isSessionPopupOpen = false;
    clearInterval(this.countdownInterval);
    localStorage.setItem('access_token', '');
    localStorage.setItem('device_id', '');
    this._ser.changeUrl('false');
    this._r.navigate(['/login']);
  }

  continueSession() {
    this.isSessionPopupOpen = false;
    clearInterval(this.countdownInterval);
    this.resetInactivityTimer();
  }

  ngOnDestroy() {
    clearTimeout(this.inactivityTimer);
    clearTimeout(this.warningTimer);
    clearInterval(this.countdownInterval);
  }

}
